export default __webpack_public_path__ + "static/media/signal-medium.4b811c18.svg";